<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 17.075 21.345">
        <g id="user_name" data-name="user name" transform="translate(61.541 -45.824)">
            <path id="Path_69777" data-name="Path 69777"
                  d="M12.247,13.387a5.549,5.549,0,0,0,2.819-4.411c.033-.422-.006-.532,0-.854a5.546,5.546,0,1,0-8.237,5.265A7.268,7.268,0,0,0,1,20.5a.427.427,0,0,0,.122.3,11.766,11.766,0,0,0,16.832,0,.427.427,0,0,0,.122-.3,7.268,7.268,0,0,0-5.829-7.114ZM9.538,3.853a4.7,4.7,0,0,1,4.674,4.269H4.863A4.7,4.7,0,0,1,9.538,3.853ZM4.864,8.976h9.349a4.693,4.693,0,0,1-9.349,0Zm6.293,5.14-.26,1.264H8.178l-.26-1.264C8.385,14.091,10.706,14.092,11.157,14.115Z"
                  transform="translate(-62.541 42.824)" fill="#799cfb"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IPerson",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
